import { handleGetYourQuoteClick } from './getYourQuote.helper';

export function clickListener(event) {
  // FAQ section start
  const closestFAQAncestor = event.target.closest('.faq-item');
  const faqAnswerChild =
    closestFAQAncestor?.getElementsByClassName('faq-answer')[0];
  const isFAQItem = closestFAQAncestor?.className === 'faq-item';

  if (
    isFAQItem &&
    faqAnswerChild?.classList.contains('faq-answer-transition')
  ) {
    faqAnswerChild?.classList.remove('faq-answer-transition');
  } else if (
    isFAQItem &&
    !faqAnswerChild?.classList.contains('faq-answer-transition')
  ) {
    faqAnswerChild?.classList.add('faq-answer-transition');
  }
  // FAQ section end

  // Buttons yellow and green start
  const isGetYourQuoteButton = event.target.closest(
    'button.button, button.trackingCTA',
  );
  if (isGetYourQuoteButton) {
    const selectedLanguage = event.target.getAttribute('data-language') || 'es';
    handleGetYourQuoteClick(selectedLanguage);
  }
  // Buttons yellow and green end
}
